import { atom } from "jotai";

import {
  currentBookingAtom,
  currentSessionUserClientIdAtom,
} from "../../stores";

export const getCurrentRoundBasedOnCurrentSessionClientIdAtom = atom((get) => {
  const currentBooking = get(currentBookingAtom);
  const currentSessionUserClientId = get(currentSessionUserClientIdAtom);

  if (!currentBooking || !currentSessionUserClientId) {
    return null;
  }

  return (
    currentBooking.rounds.find(
      (round) => round.player.id === currentSessionUserClientId
    ) ?? null
  );
});
